import { debounce, isBelow, onDomReady } from '../utils/dom';

let collapses: HTMLElement[] = [];
let toggles: HTMLElement[] = [];

function updateCollapseState(): void {
    const isMobile = isBelow('sm');

    collapses.forEach(collapse => {
        if (isMobile) {
            collapse.classList.remove('show');
        } else {
            collapse.classList.add('show');
        }
    });
}

function init(): void {
    collapses = [...document.querySelectorAll<HTMLElement>('footer .collapse')];
    toggles = [...document.querySelectorAll<HTMLElement>('footer [data-bs-toggle="collapse"]')];

    collapses.forEach(collapse => {
        collapse.addEventListener('hide.bs.collapse', (e: Event) => {
            if (!isBelow('sm')) {
                e.preventDefault();
            }
        });
        collapse.addEventListener('show.bs.collapse', (e: Event) => {
            if (!isBelow('sm')) {
                e.preventDefault();
            }
        });
    });

    toggles.forEach(toggle => {
        toggle.addEventListener('click', () => {
            if (isBelow('sm')) {
                const target = toggle.dataset.bsTarget || toggle.getAttribute('href');
                
                if (target) {
                    const collapse = document.querySelector<HTMLElement>(target);
                    
                    if (collapse) {
                        collapse?.classList.remove('d-none', 'd-sm-block');
                    }
                }
            }
        });
    });

    window.addEventListener('resize', debounce(updateCollapseState, 100));
}

onDomReady(init);